import type { FlexibleRange } from '@/infrastructure/departure-date/store'
import type { DepartureDateFilterOptions } from '@/scopes/search/components/DepartureDateFilter/types'
import { useIntl } from '@/intl'

import { getDaysAround, removePastDatesFromRange, tokPx } from '@sunwebgroup/ui-components'
import { ToggleButton, ToggleButtonGroup } from '@sunwebgroup/ui-components/uds'

import { add } from 'date-fns'
import * as React from 'react'
import { styled } from 'styled-components'
import { useDepartureDateFilter } from './hooks'

const ToggleGroup = styled(ToggleButtonGroup)`
  display: flex;
  gap: ${tokPx('components_toggle_button_group_s_spacing')};
`

function ToggleComponent({ options, ...rest }: { options: DepartureDateFilterOptions }) {
  const intl = useIntl()
  const { flexibleRange, originDate, setDepartureDate, setFlexibleRange } = useDepartureDateFilter({ options })

  function handleValueChange(value: FlexibleRange) {
    setFlexibleRange(value)

    if (value === 'exact') {
      return setDepartureDate(originDate)
    }

    const numberOfDays = Number.parseInt(value)
    const date = originDate
    const depDate = date ? getDaysAround(date, numberOfDays) : date
    if (Array.isArray(depDate) && date) {
      const minimDepartureDate = add(new Date(), { days: 1 })
      setDepartureDate(removePastDatesFromRange(depDate, minimDepartureDate))
    }
    else {
      setDepartureDate(depDate)
    }
  }

  return (
    <ToggleGroup type="single" onValueChange={handleValueChange} defaultValue={flexibleRange || 'exact'} {...rest}>
      <ToggleButton
        id="r1"
        value="exact"
        disabled={flexibleRange === 'exact'}
        title={intl.formatMessage({ id: 'quicksearch_filter_departure_date_exact_date' })}
        size="S"
      />
      <ToggleButton
        id="r2"
        value="1 day"
        disabled={flexibleRange === '1 day'}
        title={intl.formatMessage({ id: 'quicksearch_filter_departure_date_chips_number_of_days' }, { n_days: 1 })}
        size="S"
      />
      <ToggleButton
        id="r3"
        value="3 days"
        disabled={flexibleRange === '3 days'}
        title={intl.formatMessage({ id: 'quicksearch_filter_departure_date_chips_number_of_days' }, { n_days: 3 })}
        size="S"
      />
      <ToggleButton
        id="r4"
        value="7 days"
        disabled={flexibleRange === '7 days'}
        title={intl.formatMessage({ id: 'quicksearch_filter_departure_date_chips_number_of_days' }, { n_days: 7 })}
        size="S"
      />
    </ToggleGroup>
  )
}

export const Toggle = styled(ToggleComponent)``
